export const toTitleCase = (str) =>{
  const titleCase = str && str
      .toLowerCase()
      .split(' ')
      .map(word => {
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(' ');

  return titleCase;
}